define(['marionette'], function (Marionette) {
  return Marionette.View.extend({
    el: '#content_layout',

    ui: {
      promotionEndModal: '#promotion-end-modal',
    },

    initialize: function () {
      this.bindUIElements();
      this.ui.promotionEndModal.modal({ show: true });
    },
  });
});
